// v-no-translate — opt an element out of browser page-translation
// (Chrome / Google Translate, Edge, etc.).
//
// The `translate` attribute is INHERITED, so marking a container also covers
// every descendant — including nodes the framework/library creates later
// (AG Grid virtualized cells, chart overlays). Use it on DATA regions: grids,
// chart containers, identifier/number outputs.
//
// Two reasons this matters in a data app:
//   1. Correctness — backend values (ASIN, SKU, names, numbers, currency codes)
//      are facts, not language; auto-translating them corrupts meaning.
//   2. Stability — Google Translate rewrites text nodes (wrapping them in <font>
//      and moving them), which makes Vue's virtual-DOM patch crash
//      ("Failed to execute 'removeChild'…" / "…reading 'insertBefore'").
//
// UI chrome is intentionally left translatable so browser MT can still serve
// languages our own i18n doesn't ship.

const apply = (el) => {
  el.setAttribute('translate', 'no');
  // `notranslate` is Google's legacy convention — set both for max coverage.
  el.classList.add('notranslate');
};

export default (app) => {
  // Re-assert on update too: a parent re-render can recreate the element and
  // drop the attribute; the directive keeps it pinned.
  app.directive('no-translate', { mounted: apply, updated: apply });
};
